import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'htmlFromText'
})
export class HtmlFromTextPipe implements PipeTransform {

  constructor(private ds: DomSanitizer) { }

  transform(value: string): SafeHtml {
    return this.ds.bypassSecurityTrustHtml(value);
  }
}
